// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HashRouter, Routes, Route } from "react-router-dom";
import FunctionPage from "wbr/function_page/FunctionPage";
import AuthGuard from "shared/auth-guard/AuthGuard";
import { PermissionsProvider } from "shared/context/PermissionsContext";
import { UserProvider } from "shared/context/UserContext";
import ErrorBoundary from "shared/ErrorBoundary";

import PulseAdmin from "wbr/pulseadmin/PulseAdmin";
import OnboardPage from "wbr/onboard/OnboardPage";
import AutomationPage from "automation/AutomationPage";

import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "shared/lib/queryClient";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthGuard>
        <QueryClientProvider client={queryClient}>
          <UserProvider>
            <PermissionsProvider>
              <HashRouter>
                <Routes>
                  <Route path="/" element={<App />} />
                  <Route path="/pulse-admin" element={<PulseAdmin />} />
                  <Route path="/onboard" element={<OnboardPage />} />
                  <Route path="/automation/:id" element={<AutomationPage />} />
                  <Route path="/:id" element={<FunctionPage />} />
                </Routes>
              </HashRouter>
            </PermissionsProvider>
          </UserProvider>
        </QueryClientProvider>
      </AuthGuard>
    </ErrorBoundary>
  </React.StrictMode>,
);
